jQuery(function() {
  $('#notesCollapse').on('show.bs.collapse', function(event) {
    return $('.notes-collapse-button').addClass('active');
  });
  return $('#notesCollapse').on('hide.bs.collapse', function(event) {
    return $('.notes-collapse-button').removeClass('active');
  });
});
